import { useContext, useEffect, useState } from "react";
import client from "../../../contentfulClient";
import "./AboutUsBaner.scss";
import { MainContext } from "../../../MainContext";

export const AboutUsBaner = () => {
    const {
        staticTexts: { polygraph: staticTexts },
        staticTexts: { learnMoreButton: learnMoreButton },
        polygraphTypesRef,
        polygraphTypes,
        openModal,
        lang
    } = useContext(MainContext);

    return (
        <div className="about-container">
            <div
                className="card"
                ref={(el) => {
                    if (el) polygraphTypesRef.current[polygraphTypes.length + 1] = el;
                }}
            >
                <img className="card-image" src={staticTexts.image} alt="" />

                <div lang={lang} className="text-container">
                    <div>
                        <h2 className="text-header">{staticTexts.title}</h2>
                        <p>{staticTexts.subTitle}</p>
                    </div>
                    <div className="btn-blue" onClick={() => openModal({ ...staticTexts })}>
                        {learnMoreButton.text}
                    </div>
                </div>
            </div>
        </div>
    );
};
